export class NonExistingTreePathError extends Error {
  constructor(path) {
    super(
      `Seems like there is no path matching "${path}".\nIt might be that you are trying to find a member, in that case use getMemberByType method.`,
    );
    this.name = 'NonExistingTreePathError';
  }
}
